import { baseApi } from "./api";

export interface SearchResultCourse {
  id: number;
  name: string;
  slug: string;
  description?: string | null;
  thumbnail_url?: string | null;
  level?: string;
  module_count?: number;
  is_free?: boolean;
}

export interface SearchResultModule {
  id: number;
  name: string;
  slug: string;
  course_id: number;
  course_name?: string;
  course_slug?: string;
  exercise_count?: number;
}

export interface SearchResultExercise {
  id: number;
  name: string;
  slug?: string | null;
  type?: string;
  difficulty?: number;
  module_id: number;
  module_name?: string;
  module_slug?: string;
  course_id?: number;
  course_name?: string;
  course_slug?: string;
}

export interface SearchResults {
  courses: SearchResultCourse[];
  modules: SearchResultModule[];
  exercises: SearchResultExercise[];
}

export const searchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    search: builder.query<SearchResults, { q: string; lang?: string }>({
      query: ({ q, lang }) => ({
        url: `/search?q=${encodeURIComponent(q)}${lang ? `&lang=${lang}` : ""}`,
      }),
      keepUnusedDataFor: 30,
    }),
  }),
  overrideExisting: true,
});

export const { useSearchQuery } = searchApi;
